import { Box, Button, Typography } from '@mui/material';

import { useTranslation } from '@shared/i18n';

import { useAppLoader } from 'component/hooks/useAppLoader';

interface MessageLayoutProps {
  readonly message?: string;
  readonly hasLoader?: boolean;
  readonly hasDashboardButton?: boolean;
}

export function MessageLayout({ message, hasLoader, hasDashboardButton }: MessageLayoutProps) {
  const { t } = useTranslation();

  useAppLoader(message, !!hasLoader);

  if (hasLoader) {
    return null;
  }

  const dashboardLink = '/n/sites';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 6,
        gap: 6,
      }}
    >
      <Typography variant="body1" sx={{ textAlign: 'center' }}>
        {message}
      </Typography>
      {hasDashboardButton ? (
        <Button variant="contained" color="primary" href={dashboardLink}>
          {t('common.dashboard')}
        </Button>
      ) : null}
    </Box>
  );
}
